'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

const ArrowRight = props => /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
  width: "16",
  height: "16",
  fill: "#000",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.354 8.354a.5.5 0 0 0 0-.708L9.172 4.464a.5.5 0 1 0-.708.708L11.293 8l-2.829 2.828a.5.5 0 1 0 .708.708l3.182-3.182ZM4 8.5h8v-1H4v1Z",
  fill: "inherit"
}));

exports["default"] = ArrowRight;
